"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
require("../../common/style.scss");
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
var _tpmProductIntl = require("@tencent/tpm-product-intl");
var _reportUtil = require("../../utils/reportUtil");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
const _excluded = ["text", "href"],
  _excluded2 = ["text", "href"],
  _excluded3 = ["btnList"],
  _excluded4 = ["isLogin"];
/**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const formatAdvantageCommon = (properties, options = {}) => {
  const _ref = properties || {},
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$productList = _ref.productList,
    productList = _ref$productList === void 0 ? [] : _ref$productList,
    _ref$navList = _ref.navList,
    navList = _ref$navList === void 0 ? [] : _ref$navList,
    _ref$overflowText = _ref.overflowText,
    overflowText = _ref$overflowText === void 0 ? '' : _ref$overflowText,
    _ref$link = _ref.link,
    link = _ref$link === void 0 ? {} : _ref$link,
    _ref$btnsList = _ref.btnsList,
    btnsList = _ref$btnsList === void 0 ? [] : _ref$btnsList;
  const handledItemsList = productList === null || productList === void 0 ? void 0 : productList.map((activityItem, index) => {
    const _ref2 = activityItem || {},
      _ref2$text = _ref2.text,
      text = _ref2$text === void 0 ? '' : _ref2$text,
      _ref2$href = _ref2.href,
      href = _ref2$href === void 0 ? '' : _ref2$href,
      other = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
    const btnExtendProps = {
      'report-event': 'click_TopNav_product_item',
      'report-ext1': index,
      'report-ext2': text || '',
      'report-ext3': href || ''
    };
    return _objectSpread(_objectSpread({}, other), {}, {
      text,
      href,
      btnExtendProps
    });
  });
  const handledNavList = navList === null || navList === void 0 ? void 0 : navList.map((activityItem, index) => {
    const _ref3 = activityItem || {},
      _ref3$text = _ref3.text,
      text = _ref3$text === void 0 ? '' : _ref3$text,
      _ref3$href = _ref3.href,
      href = _ref3$href === void 0 ? '' : _ref3$href,
      other = (0, _objectWithoutProperties2.default)(_ref3, _excluded2);
    const btnExtendProps = {
      'report-event': 'click_TopNav_nav_item',
      'report-ext1': index,
      'report-ext2': text || '',
      'report-ext3': href || ''
    };
    return _objectSpread(_objectSpread({}, other), {}, {
      text,
      href,
      btnExtendProps
    });
  });
  if (link !== null && link !== void 0 && link.text && link !== null && link !== void 0 && link.href) {
    link.btnExtendProps = {
      'report-event': 'click_TopNav_link',
      'report-ext2': (link === null || link === void 0 ? void 0 : link.text) || '',
      'report-ext3': (link === null || link === void 0 ? void 0 : link.href) || ''
    };
  }
  return {
    title,
    overflowText,
    link: link.text && link.href ? link : null,
    productList: handledItemsList,
    // 这里用于兼容现网
    navList: link.text && link.href ? [...handledNavList, _objectSpread(_objectSpread({}, link), {}, {
      isBlank: true
    })] : handledNavList,
    btnList: btnsList
  };
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  if (Object.keys(data).length > 1) {
    const _formatAdvantageCommo = formatAdvantageCommon(data, {
        domains
      }),
      _formatAdvantageCommo2 = _formatAdvantageCommo.btnList,
      btnList = _formatAdvantageCommo2 === void 0 ? [] : _formatAdvantageCommo2,
      heroData = (0, _objectWithoutProperties2.default)(_formatAdvantageCommo, _excluded3);
    const _React$useState = React.useState(/*#__PURE__*/React.createElement(React.Fragment, null)),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      btnElList = _React$useState2[0],
      setBtnElList = _React$useState2[1];
    React.useEffect(() => {
      const uin = _jsCookie.default.get('uin') || '';
      const skey = _jsCookie.default.get('skey') || '';
      const hasLogin = !!(uin && skey);
      const handledBtnList = btnList === null || btnList === void 0 ? void 0 : btnList.map((activityItem, index) => {
        const _ref4 = activityItem || {},
          _ref4$isLogin = _ref4.isLogin,
          isLogin = _ref4$isLogin === void 0 ? false : _ref4$isLogin,
          other = (0, _objectWithoutProperties2.default)(_ref4, _excluded4);
        let hiddenBtn = false;
        if (isLogin && hasLogin) {
          hiddenBtn = true;
        }
        return _objectSpread(_objectSpread({}, other), {}, {
          isLogin,
          hiddenBtn,
          hasLogin
        });
      });
      const showBtnList = (handledBtnList || []).filter(item => !item.hiddenBtn);
      const handledToBtnList = showBtnList === null || showBtnList === void 0 ? void 0 : showBtnList.map((activityItem, index) => {
        const _ref5 = activityItem || {},
          _ref5$text = _ref5.text,
          text = _ref5$text === void 0 ? '' : _ref5$text,
          _ref5$href = _ref5.href,
          href = _ref5$href === void 0 ? '' : _ref5$href;
        const btnExtendProps = {
          'report-event': 'click_TopNav_btn_item',
          'report-ext1': index,
          'report-ext2': text || '',
          'report-ext3': href || '',
          target: '_blank'
        };
        let type = 'primary';
        if (index === 0 && showBtnList.length >= 2) {
          type = 'weak';
        }
        return /*#__PURE__*/React.createElement(_tpmProductIntl.Button, Object.assign({
          type: type,
          href: href
        }, btnExtendProps), text);
      });
      const convertToFragment = elements => /*#__PURE__*/React.createElement(React.Fragment, null, elements.map((element, index) => {
        return element;
      }));
      const resBtnList = convertToFragment(handledToBtnList);
      setBtnElList(resBtnList);
    }, []);
    return /*#__PURE__*/React.createElement("div", Object.assign({
      className: "gems-materials-qci__newUI-topNav"
    }, (0, _reportUtil.reportShow)(['show_newUI_TopNav', componentKey, (heroData === null || heroData === void 0 ? void 0 : heroData.title) || ''])), /*#__PURE__*/React.createElement(_tpmProductIntl.TopNav, Object.assign({}, heroData, {
      btnList: btnElList
    })));
  } else {
    return /*#__PURE__*/React.createElement("div", null);
  }
}